const BENEFICIARY_ACTION_TYPES = {
    ASSOCIATE_CONTRACT: 'ASSOCIATE_CONTRACT',
    UPDATE_LABEL: 'UPDATE_LABEL',
    DELETE_BENEFICIARY: 'DELETE_BENEFICIARY'
};

export default BENEFICIARY_ACTION_TYPES;